var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.03 6.6c0 .94.25 1.5.8 2.13.41.48.54 1.08.54 1.74 0 .65-.21 1.28-.64 1.78-.57.6-1.36 1-2.18 1.06-1.18.1-2.35.19-3.55.19-1.2 0-2.37-.06-3.55-.19a3.4 3.4 0 0 1-2.18-1.06 2.71 2.71 0 0 1-.65-1.78c0-.66.14-1.26.55-1.74.57-.64.8-1.2.8-2.13v-.32c0-1.26.31-2.09.96-2.9A5.3 5.3 0 0 1 8.97 1.5h.06c1.56 0 3.16.74 4.1 1.97.62.79.9 1.58.9 2.8v.33Zm-7.22 8.45c0-.38.34-.56.66-.63.38-.08 2.66-.08 3.04 0 .32.07.66.25.66.63-.01.36-.23.67-.52.88a2.73 2.73 0 0 1-2.04.54c-.46-.06-.9-.25-1.28-.54-.3-.2-.5-.52-.52-.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellmedium);
export default __webpack_public_path__ + "static/media/bell.medium.86856c550fcb6c2ee60c7b3c6a0aa38e.svg";
export { ForwardRef as ReactComponent };